export enum StorageKey {
	ProjectId = 'admin.portal.projectId',
	CookieName = 'admin.portal.cookieName',
	ThemeMode = 'admin.portal.themeMode',
	SidebarOpen = 'admin.portal.sidebarOpen'
}

export enum QueryParam {
	Token = 't',
	TenantId = 'tenantId',
	CookieName = 'cookieName',
	Theme = 'theme',
	SidebarOpen = 'sidebarOpen'
}
